import axios from "axios";

export default {
  namespaced: true,
  state: {
    alerts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    alertsMessage: ''
  },
  mutations: {
    RECEIVED_ALERTS(state, payload) {
      state.alerts = payload;
      state.isReceiving = false;
    },
    RECEIVING_ALERTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_ALERT(state, payload) {
      state = Object.assign(state, {
        alerts: [...state.alerts, payload],
        isReceiving: false,
      })
    },
    RECEIVING_ALERT(state) {
      state.isReceiving = true;
    },
    UPDATED_ALERT(state, payload) {
      console.log(state.alerts);
      console.log(payload);
      let index = state.alerts.findIndex(alert => alert._id === payload._id);
      state = Object.assign(state, {
        alerts: state.alerts.map((alert, i) => {
          if (i === index) {
            return Object.assign({}, alert, payload);
          }
          return alert;
        }),
        isUpdating: false,
        alertsMessage: 'Alerts has been updating!',
      })
    },
    UPDATING_ALERT(state) {
      state.isUpdating = true;
    },
    DELETED_ALERT(state, payload) {
      let indexToDelete = state.alerts.findIndex(alert => alert._id === payload._id);
      let alerts = [...state.alerts];
      alerts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        alerts: [...alerts],
        isDeleting: false,
        idToDelete: null,
        alertsMessage: 'Alert has been Deleted!',
      });
    },
    DELETING_ALERT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteAlertRequest({dispatch}, payload) {
      dispatch("deletingAlert", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/alert/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url, headers: headers})
      .then(response => {
        dispatch("deleteAlert", response.data);
      })
      .catch(function (error) {
        console.log(error.response.data.error);
      });
    },
    async deleteAlertItemRequest({dispatch}, payload) {
      try{
        dispatch("deletingAlert", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/alertitem/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteAlert", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getAlertsRequest({dispatch}) {
      dispatch("receivingAlerts");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/alerts';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveAlerts", res.data);
      })
    },
    insertAlertRequest({dispatch}, payload) {
      dispatch("receivingAlerts");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/alert';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "post", url: url, headers: headers, data: data})
      .then(response => {
        dispatch("receiveAlert", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    async insertAlertItemRequest({dispatch}, payload) {
      try{
        dispatch("receivingAlert");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/alertitem/' + payload.alertid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertAlertItemWithImageRequest({dispatch}, payload) {
      try{
        dispatch("receivingAlert");
        let url = 'https://api.tradexc.com:3000/insert/alertitem/withimage/' + payload.alertid;
        let data = new FormData();
        data.append('file', payload.imagefile, payload.imagefilename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateAlertRequest({dispatch}, payload) {
      dispatch("updatingAlert");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/alert/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(response => {
        dispatch("updateAlert", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateAlertItemRequest({dispatch}, payload) {
      try{
        dispatch("receivingAlert");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/alertitem/' + payload.alertitemid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveAlert", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateAlertItemWithImageRequest({dispatch}, payload) {
      try{
        dispatch("updatingAlert");
        let url = 'https://api.tradexc.com:3000/update/alertitem/withimage/' + payload.alertitemid;
        let data = new FormData();
        data.append('file', payload.imagefile, payload.imagefilename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updateAlert", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    receiveAlerts({commit}, payload) {
      commit("RECEIVED_ALERTS", payload)
    },
    receivingAlerts({commit}) {
      commit("RECEIVING_ALERTS")
    },
    receiveAlert({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_ALERT", payload)
    },
    receivingAlert({commit}) {
      commit("RECEIVING_ALERT")
    },
    updateAlert({commit}, payload) {
      commit("UPDATED_ALERT", payload)
    },
    updatingAlert({commit}) {
      commit("UPDATING_ALERT")
    },
    deleteAlert({commit}, payload) {
      console.log(payload);
      commit("DELETED_ALERT", payload)
    },
    deletingAlert({commit}, payload) {
      commit("DELETING_ALERT", payload)
    }
  },
};
